import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from "prop-types";

import { connect } from 'react-redux';
import {
  fetchCommerceLinksList,
  addCommerceLink,
  clearAddCommerceLink,
} from 'redux/commerce/actions';

import Button from 'components/elements/buttons/Button';
import OutsideHandler from 'components/common/OutsideHandler';
import CommonMessage from 'components/common/CommonMessage';

import './AddCommerceLink.css';


function AddCommerceLink(props) {
  const {
    fetchCommerceLinksList,
    addCommerceLink,
    clearAddCommerceLink,
    addCommerceLinkSuccess,
    addCommerceLinkError,
    me,
  } = props;
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    return () => {
      setPopupOpen(false);
    };
  }, []);

  useEffect(() => {
    if (addCommerceLinkSuccess) {
      fetchCommerceLinksList();
      clearAddCommerceLink();
    }
  }, [addCommerceLinkSuccess]);

  const handleClickOutside = () => { setPopupOpen(false); };

  const onItemClick = type => {
    setPopupOpen(false);
    addCommerceLink(type);
  };

  const itemsList = [
   {
      type: 'donations',
      title: 'Tips & Donations',
      description: 'Enable your audience to support you through tips and donations',
      onClick: () => onItemClick('donation'),
    },
    {
      type: 'payment-form',
      title: 'Payment Form',
      description: 'Collect payments from your audience',
      onClick: () => onItemClick('payment_form'),
    },
    // {
    //   type: 'products-services',
    //   title: 'Products & Services',
    //   description: 'Start selling your products or services',
    //   onClick: () => onItemClick('products-services'),
    // },
    // {
    //   type: 'subscriptions',
    //   title: 'Subscriptions',
    //   description: 'Enable your audience to subscribe to your services',
    //   onClick: () => onItemClick('subscriptions'),
    // },
  ];

  const renderPopupItems = () => itemsList.map(item => (
    <div
      className="commerce-link-item"
      onClick={item.onClick}
      role="button"
      tabIndex={-1}
    >
      <div className={`icon ${item.type}`} />
      <div className="description">
        <div className="title">{item.title}</div>
        <div className="text">{item.description}</div>
      </div>
    </div>
  ));

  const paymentProvidersDisabled = (
    (me.payment_provider && me.payment_provider.length === 0) ||
    (me.payment_provider && me.payment_provider.filter(item => item.charges_enabled === true).length === 0)
  );

  return (
    <div className="add-commerce-link__component">
      <OutsideHandler handleClickOutside={handleClickOutside}>
        <Fragment>
          <div className="buttons-block">
            <Button
              small
              onClick={() => { setPopupOpen(true); }}
              disabled={paymentProvidersDisabled}
            >
              + Add Commerce Link
            </Button>
          </div>

          {popupOpen &&
            <div className="commerce-popup">
              {renderPopupItems()}
            </div>
          }
        </Fragment>
      </OutsideHandler>

      {/* Add Errors */}
      {addCommerceLinkError &&
        <CommonMessage
          error
          errors={addCommerceLinkError}
        />
      }
    </div>
  );
}

AddCommerceLink.propTypes = {
  me: PropTypes.object,
  fetchCommerceLinksList: PropTypes.func.isRequired,
  addCommerceLink: PropTypes.func.isRequired,
  clearAddCommerceLink: PropTypes.func.isRequired,
  addCommerceLinkSuccess: PropTypes.object,
  addCommerceLinkError: PropTypes.object,
};

AddCommerceLink.defaultProps = {
  mer: null,
  addCommerceLinkSuccess: null,
  addCommerceLinkError: null,
};

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
    addCommerceLinkSuccess: state.commerceReducer.addCommerceLinkSuccess,
    addCommerceLinkError: state.commerceReducer.addCommerceLinkError,
  }
);

export default connect(
  mapStateToProps,
  {
    fetchCommerceLinksList,
    addCommerceLink,
    clearAddCommerceLink,
  },
)(AddCommerceLink);
